'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagPkAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.22869e-06 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C0 13.3333 -4.01451e-05 6.66667 6.22869e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M28 0H8V20H28V0Z", fill: "#0A632F" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M23.6701 10.7505C23.5418 12.0012 23.0087 13.2029 22.0665 14.1451C19.8206 16.391 16.1005 16.3121 13.7574 13.969C11.4142 11.6258 11.3354 7.90569 13.5812 5.65983C14.5234 4.71761 15.7251 4.18456 16.9758 4.05623C16.5818 4.28839 16.209 4.57486 15.8685 4.91528C13.8268 6.95697 13.7259 10.1662 15.643 12.0833C17.5601 14.0005 20.7694 13.8995 22.811 11.8578C23.1515 11.5174 23.4379 11.1445 23.6701 10.7505ZM21.0924 8.10469L20.7742 10.0031L19.8849 8.29595L17.981 8.57994L19.3298 7.20661L18.4714 5.48369L20.1943 6.34211L21.5677 4.99329L21.2837 6.89715L22.9909 7.78646L21.0924 8.10469Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagPkAsset = forwardRef(FlagPkAsset);

export { VpFlagPkAsset as default };
